import { createFileRoute } from "@tanstack/react-router";
import { setPageTitle } from "@/components/app-shell/app-shell";
import { authorizeFeatures } from "@/lib/authorize-feature";

export const Route = createFileRoute("/_app/threat-intel")({
  beforeLoad: async ({ context }) => {
    setPageTitle("Threat Intel");
    await authorizeFeatures(context, ["detect", "threat_intel"]);
  },
});
